import React, {useEffect, useState, useRef} from 'react';
import Chart from "react-apexcharts";
import {Box, Heading, Tooltip, Flex, Spacer} from "@chakra-ui/react"
import {InfoOutlineIcon} from "@chakra-ui/icons"


export default function AspectSensitivity({product_ids, show_title = true, handleReviewUpdate}) {
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const dataRef = useRef()
    dataRef.current = data;
    console.log("URLL", `${process.env.REACT_APP_API_URL}/aspectSensitivity`)
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/aspectSensitivity`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'//`${process.env.REACT_APP_API_URL}`
            },
            body: JSON.stringify({product_id_list: product_ids})
        })
            .then(res => res.json())
            .then(
                (result_json) => {
                    const result = JSON.parse(result_json)
                    console.log("RESULT", result);
                    let data = []
                    const idx_aspect = result.columns.findIndex(elem => elem === 'aspect')
                    const idx_coeff = result.columns.findIndex(elem => elem === 'coeff')
                    if (idx_aspect == null || idx_coeff == null) {
                        setError('Error! Malformed response.')
                    }
                    for (const row of result.data) {
                        data.push({x: row[idx_aspect], y: Number(row[idx_coeff].toFixed(2))})
                    }
                    setIsLoaded(true);
                    setData(data);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, [product_ids])


    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div>Loading...</div>;
    }
    console.log("DATAAA", data)
    let options = {
        chart: {
            type: 'bar',
            events: {
                click: (event, chartContext, config) => {
                    if (config.dataPointIndex >= 0) {
                        handleReviewUpdate(dataRef.current[config.dataPointIndex].x, "all"
                        )
                    }
                }
            }
        },
        yaxis: {
            forceNiceScale: true,
            title: {
                text: 'Aspect Sensitivity'
            }
        },
        dataLabels: {
            enabled: false
        }
    }

    return (
        <Box>
            {show_title ?
                <Flex>
                    <Heading size="md">Sensitivity of Ratings to Specific Aspects</Heading>
                    <Spacer/>
                    <Tooltip label="High sensitivity = better sentiment for the aspect means better product ratings and low sentiment for the aspect means poor product ratings.
                 Low sensitivity = better or worse sentiment for the aspect does not move the product rating too much."><InfoOutlineIcon/></Tooltip>
                </Flex>
                : null}
            <Chart options={options} series={[{name: 'Sensitivity', 'data': data}]} type="bar"/>
        </Box>
    )

}